import React from "react";

type articletype = {
  article: {
    date: string;
    author: string;
    icon: string;
    category: string;
    title: string;
    description: string;
    img: string;
    alt: string;
    showHomePage: boolean;
    articleURL: string
  }[];
  page?: string;
};

const LeftImgRightText = (props: articletype) => {
  const { article, page } = props;

  return (
    <React.Fragment>
      {article.map((item, index) => {
        return (
          <React.Fragment key={index}>
            {(page === undefined || page === null || page === "") && (
              <div className="row" >
                <div className="col-sm-3 ">
                  <div className="teaserimg text-center">
                    <img src={item.img ? item.img : "/images/no-image.jpg"} alt={item.alt} />
                  </div>
                </div>
                <div className="col-sm-9 itemlink">
                  <a href={item.articleURL.toLowerCase()}>{item.title}</a>
                </div>
              </div>
            )}
            {page === "profile" && (<>
              <div className="col-xl-3 teaserimg" style={{ textAlign: "center" }}>
                <img alt={item.alt} src={item.img} />
              </div>
              <div className="col-xl-9 itemlink">
                <a href={item.articleURL.toLowerCase()}>{item.title}</a>
              </div>
            </>)}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

export default LeftImgRightText;
